import gmapStyle from './maps-style.json'

export const gmapsApiKey = process.env.VUE_APP_GMAPS_API_KEY

export default {
  apiKey: gmapsApiKey,
  defaultLocation: {
    lat: 48.200108,
    lng: 16.344917
  },
  defaultZoom: 13,
  style: gmapStyle
}
